<template>
  <div>
    <Loading v-if="loading" />
    <div v-else-if="challenge">
      <TieredChallengeHeader v-if="isTiered" :challenge="challenge" :store-count="challengeStoreCount" class="mb-6" />
      <ChallengePerformances :challenge="challenge" :performance="performance" :selected-store-id="selectedStoreId" />
    </div>
    <div v-else class="p-6 bg-white">
      <p class="uppercase text-2xl">{{ t("no_active_challenge") }}</p>
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { mapActions, mapState } from "vuex";
import { Loading } from "@estaly/ui";
import { isTieredChallenge } from "@/utils/challengeTiers";
import ChallengePerformances from "@/components/challenge/ChallengePerformances.vue";
import TieredChallengeHeader from "@/components/challenge/tiered/TieredChallengeHeader.vue";

export default {
  components: { ChallengePerformances, TieredChallengeHeader, Loading },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  data() {
    return {
      loading: true,
    };
  },

  computed: {
    ...mapState("store", ["selectedStoreId"]),
    ...mapState("challenge", ["activePerformance"]),

    challenge() {
      return this.activePerformance?.challenge ?? null;
    },

    performance() {
      return this.activePerformance?.performance ?? {};
    },

    isTiered() {
      return isTieredChallenge(this.challenge);
    },

    challengeStoreCount() {
      return this.performance.storeRankings?.totalStores || 0;
    },
  },

  async mounted() {
    await this.fetchActivePerformance(this.selectedStoreId);
    this.loading = false;
  },

  methods: {
    ...mapActions("challenge", ["fetchActivePerformance"]),
  },
};
</script>

<i18n src="./CurrentChallenge.i18n.json"></i18n>
